module.exports = __webpack_public_path__ + "static/media/Payments.e41023a5.png";